<template>
  <div v-if="false"></div>
</template>

<script>
import { ON_INPUT_PAD_BLUR } from '@/store/mutation-types';
export default {
  name: 'order',
  mounted() {
    this.$store.commit(ON_INPUT_PAD_BLUR, true);
    this.$store.state.toggle.isMenuSideVisible = false;
  },
};
</script>
